<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar" v-if="report">
			<span class="view-title">{{ report.Name || '' }}</span>
			<v-row class="quick-filter-container" no-gutters></v-row>
			<!-- Desktop Export Modal (≥lg) -->
			<export-modal
				class="d-flex"
				:timezone-options="true"
				:execution-options="false"
				:data-scope-options="true"
				@exportModalEvent="onExportModalEvent"
			>
				<template #activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						class="export"
						color="primary"
					>
						<v-icon class="mr-1">mdi-cloud-download</v-icon>
						Export
					</v-btn>
				</template>
			</export-modal>
		</div>

		<div class="generic-grid-container">
			<report-preview-custom-data :report="report" v-if="report" />
		</div>
	</div>
</template>

<script>
import ReportPreviewCustomData from '../../tools/reportBuilder/reportDetails/reportPreview/ReportPreviewCustomData.vue';
import { ReportPreviewActions } from '../../../store/actions';
import { ReportPreviewGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
import ExportModal from '../../shared/export/ExportModal.vue';

export default {
	name: 'ReportGridCustom',
	components: { ReportPreviewCustomData, ExportModal },
	computed: {
		...mapGetters({
			report: [ReportPreviewGetters.REPORT],
		}),
		currentReportId() {
			return this.$route.params.reportId;
		},
	},
	data() {
		return {
			dotsMenuOpen: false,
		};
	},
	mounted() {
		if (this.currentReportId) {
			this.$store.dispatch(
				ReportPreviewActions.LOAD_REPORT_BY_ID,
				this.currentReportId
			);
		}
	},
	destroyed() {
		this.$store.dispatch(ReportPreviewActions.CLEAR);
	},
	methods: {
		onExportModalEvent(exportConfig) {
			this.$store.dispatch(ReportPreviewActions.EXPORT_CUSTOM_DATA, {
				allData: exportConfig.allData,
				isDirectMode: !exportConfig.isBackgroundExport,
			});
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
	},
};
</script>
